import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Import actions
import {
	fetchActivePaymentMethods,
	fetchLastGatewayType,
	fetchPaymentAgreements,
	fetchPaymentTypes,
	fetchProductPackets,
	fetchUserDetails,
	setFinalPromotion
} from 'store/actions';

// Import utilities
import { useUserSourceType } from 'components/utilities';
import useUserAgent from 'components/utilities/hooks/user_agent/useUserAgent';

function usePaymentTemplate({ toggle, period, uuid, promotion }) {
	const dispatch = useDispatch();
	const { isMobile } = useUserAgent();
	const { isNexGenUser } = useUserSourceType();

	const {
		isLoaded,
		init: { loading: initLoading }
	} = useSelector(({ payment }) => payment);
	const { loading: purchaseLoading } = useSelector(({ purchase }) => purchase);
	const { email_approved } = useSelector(({ auth }) => auth.authenticate);

	const showLoader = initLoading || purchaseLoading;

	const handleFetchPaymentResources = async () => {
		await setFinalPromotion(promotion, dispatch);

		if (isNexGenUser) {
			await fetchActivePaymentMethods()(dispatch);
		}

		await fetchLastGatewayType()(dispatch);

		// fetch user details to check if email is approved
		if (isNexGenUser && email_approved === false) {
			await fetchUserDetails()(dispatch);
		}
		// Dispatch an fetchPaymentTypes action in payment_actions folder
		await fetchPaymentTypes(uuid, period, promotion, !isNexGenUser)(dispatch);
		// Dispatch an fetchProductPackets action in product_packets folder
		await fetchProductPackets(uuid)(dispatch);
		// Dispatch an fetchPaymentAgreements action in payment_actions folder
		fetchPaymentAgreements()(dispatch);
	};

	useEffect(() => {
		handleFetchPaymentResources();
		// eslint-disable-next-line
	}, []);

	const handleClose = () => isLoaded && toggle();

	return {
		showLoader,
		handleClose,
		isLoaded,
		isMobile
	};
}

export default usePaymentTemplate;
